import ViewsTunnelService from "@/views/tunnel/ViewsTunnelService.vue";
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: "/service/:service(.*)",
        name: "tunnel.service",
        component: ViewsTunnelService
    }
] as RouteRecordRaw[]